import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { CheckLabel } from 'components';
import { getInitials } from 'helpers/string';
import { CollaboratorAvatar } from 'components/shared/CollaboratorAvatar';

import styles from './SelectItem.module.scss';

export const SelectItem = ({
  checkbox = 'Default',
  checked,
  className,
  collaboratrorEmail,
  count,
  group,
  isGroup,
  imgURL,
  name,
  onClick,
  theme = 'Default',
}) => {
  const initials = isGroup ? getInitials(name, null, 1) : getInitials(name);
  const identifier = name ? name : collaboratrorEmail;
  const [clicked, setClicked] = useState(false);

  return (
    <div
      className={classnames(className, styles.container, {
        [styles[`theme--${theme}`]]: theme,
      })}
      title={collaboratrorEmail}
      onClick={() => {
        if (!clicked) {
          setClicked(true);
          onClick();
        }
      }}
    >
      <div className={classnames(styles.avatarWrapper)}>
        {isGroup ? (
          <CollaboratorAvatar
            bordered={false}
            emoji={group.emoji}
            type="Group"
            collaborator={{
              displayName: name,
            }}
          />
        ) : (
          <div
            className={classnames(styles.avatar, {
              [styles[`type-Group`]]: isGroup,
            })}
          >
            {(imgURL && <img src={imgURL} alt="" />) || initials}
          </div>
        )}
      </div>

      <div className={styles.nameCount}>
        <span
          className={classnames(styles.name, {
            [styles.nameGroup]: isGroup,
          })}
        >
          {identifier}
        </span>{' '}
        <span className={styles.count}>{count && `(${count})`}</span>
      </div>

      <div className={styles.timeCheck}>
        <CheckLabel
          className={styles.checkbox}
          checked={checked}
          iconClassName={styles.icon}
          inputClassName={styles.input}
          type={checkbox}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  );
};

SelectItem.propTypes = {
  checkbox: PropTypes.oneOf(['Default', 'Circle', 'Flat']),
  checked: PropTypes.bool.isRequired,
  className: PropTypes.string,
  count: PropTypes.number,
  isGroup: PropTypes.bool,
  imgURL: PropTypes.string,
  name: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  theme: PropTypes.string,
};
